// src/components/Projects.js

import { CodeIcon } from "@heroicons/react/solid";
import React from "react";

export default function Projects() {
    return (
        <section id="projects" className="text-stone-900 bg-blue-100 body-font">
        <div className="container px-5 py-10 mx-auto text-center lg:px-40">
          <div className="flex flex-col w-full mb-20">
            <CodeIcon className="mx-auto inline-block w-16 mb-4" />
            <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-stone-900">
              Deployments
            </h1>
            <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
              Improve operational performance and efficiency using the <a class="font-bold">
              Industrial Internet of Things (IIoT)</a>
            </p>
          </div>
          <div className="flex flex-col w-full mb-20">
              <img
                alt="Data Analytics for Edge Devices"
                src="./meter.png"
              />
          </div>
          <div class="container grid grid-cols-2 gap-4 mb-10 mx-auto">
            <div className="w-full rounded">
              <img
                alt="Data Analytics for Edge Devices"
                src="./01reactUI.png"
              />
            </div>
            <div className="w-full rounded">
              <img
                alt="Data Analytics for Edge Devices"
                src="./02reactUI.png"
              />
            </div>
          </div>
          <div class="container grid grid-cols-4 gap-4 mx-auto">
            <div className="w-full rounded">
              <img
                alt="Water Meter"
                src="./01meter.jpg"
              />
            </div>
            <div className="w-full rounded">
              <img
                alt="Water Meter"
                src="./02meter.jpg"
              />
            </div>
            <div className="w-full rounded">
              <img
                alt="Water Meter"
                src="./03meter.jpg"
              />
            </div>
            <div className="w-full rounded">
              <img
                alt="Water Meter"
                src="./04meter.jpg"
              />
            </div>            
          </div>
        </div>
        </section>
    )
}



// WEBPACK FOOTER //
// ./src/components/Projects.js